import * as XLSX from 'xlsx';
import { CustomerCheckoutData } from '../types/admin';

export const exportCustomerDataToExcel = (customerData: CustomerCheckoutData[], filename?: string) => {
  // Prepare data for Excel export
  const excelData = customerData.map((customer, index) => ({
    // Basic Info
    'Row #': index + 1,
    'Customer ID': customer.id,
    'First Name': customer.firstName,
    'Last Name': customer.lastName,
    'Email': customer.email,
    'Phone': customer.phone,
    'Country': customer.country,
    
    // Event Info
    'Event ID': customer.eventId,
    'Event Title': customer.eventTitle,
    
    // Order Info
    'Status': customer.status.replace('_', ' ').toUpperCase(),
    'Is Completed': customer.isCompleted ? 'YES' : 'NO',
    'Payment Method': customer.paymentMethod.toUpperCase(),
    'Ticket Type': customer.orderData?.ticketType || 'N/A',
    'Quantity': customer.orderData?.quantity || 'N/A',
    'Unit Price': customer.orderData?.price ? `$${customer.orderData.price.toFixed(2)}` : 'N/A',
    'Subtotal': customer.orderData?.subtotal ? `$${customer.orderData.subtotal.toFixed(2)}` : 'N/A',
    'Total Amount': customer.orderData?.total ? `$${customer.orderData.total.toFixed(2)}` : 'N/A',
    'Promo Code': customer.orderData?.promoCode || 'N/A',
    'Promo Discount': customer.orderData?.promoDiscount ? `$${customer.orderData.promoDiscount.toFixed(2)}` : 'N/A',
    
    // Address Info
    'Billing Address': customer.billingAddress || 'N/A',
    'Billing City': customer.city || 'N/A',
    'Billing State': customer.state || 'N/A',
    'Billing Zip': customer.zipCode || 'N/A',
    'Delivery Address': customer.deliveryAddress || 'N/A',
    'Delivery City': customer.deliveryCity || 'N/A',
    'Delivery Notes': customer.deliveryNotes || 'N/A',
    
    // Timestamps
    'Submitted Date': new Date(customer.submittedAt).toLocaleDateString(),
    'Submitted Time': new Date(customer.submittedAt).toLocaleTimeString(),
    'Full Timestamp': customer.submittedAt
  }));

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Auto-size columns
  const columnWidths = [
    { wch: 8 },  // Row #
    { wch: 15 }, // Customer ID
    { wch: 15 }, // First Name
    { wch: 15 }, // Last Name
    { wch: 25 }, // Email
    { wch: 15 }, // Phone
    { wch: 10 }, // Country
    { wch: 15 }, // Event ID
    { wch: 30 }, // Event Title
    { wch: 15 }, // Status
    { wch: 12 }, // Is Completed
    { wch: 15 }, // Payment Method
    { wch: 20 }, // Ticket Type
    { wch: 10 }, // Quantity
    { wch: 12 }, // Unit Price
    { wch: 12 }, // Subtotal
    { wch: 12 }, // Total Amount
    { wch: 15 }, // Promo Code
    { wch: 15 }, // Promo Discount
    { wch: 30 }, // Billing Address
    { wch: 15 }, // Billing City
    { wch: 15 }, // Billing State
    { wch: 12 }, // Billing Zip
    { wch: 30 }, // Delivery Address
    { wch: 15 }, // Delivery City
    { wch: 30 }, // Delivery Notes
    { wch: 12 }, // Submitted Date
    { wch: 12 }, // Submitted Time
    { wch: 20 }  // Full Timestamp
  ];
  worksheet['!cols'] = columnWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Customer Data');

  // Generate filename
  const defaultFilename = `customer-data-${new Date().toISOString().split('T')[0]}.xlsx`;
  const finalFilename = filename || defaultFilename;

  // Download file
  XLSX.writeFile(workbook, finalFilename);

  return {
    success: true,
    filename: finalFilename,
    recordCount: customerData.length
  };
};

export const exportFilteredCustomerData = (
  allCustomerData: CustomerCheckoutData[],
  filteredCustomerData: CustomerCheckoutData[],
  filters: {
    status: string;
    searchQuery: string;
  }
) => {
  // Create filename based on filters
  let filename = 'customer-data';
  
  if (filters.status !== 'all') {
    filename += `-${filters.status}`;
  }
  
  if (filters.searchQuery) {
    filename += `-search-${filters.searchQuery.replace(/[^a-zA-Z0-9]/g, '_')}`;
  }
  
  filename += `-${new Date().toISOString().split('T')[0]}.xlsx`;

  return exportCustomerDataToExcel(filteredCustomerData, filename);
}; 